import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SportIconComponent } from '../sport-icon/sport-icon.component';
import { SportMenuItem } from '../sportsbook/sportsbook.models';

@Component({
  selector: 'app-mobile-sports-bar',
  standalone: true,
  imports: [CommonModule, TranslateModule, SportIconComponent],
  templateUrl: './mobile-sports-bar.component.html',
  styleUrl: './mobile-sports-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MobileSportsBarComponent {
  readonly sports = input.required<readonly SportMenuItem[]>();
  readonly loading = input(false);

  readonly sportToggle = output<number>();

  protected readonly skeletonIndexes = Array.from({ length: 8 }, (_, index) => index);
  protected readonly trackSport = (_: number, sport: SportMenuItem): number => sport.id;
}
